import OpenModal from 'app/components/VideoModal/OpenModal';
import React from 'react';
import { getAccessServiceDescription } from '../../../../domain/AccessServiceTypes';
import CONTENTO_ACCESSIBILITIES from '../../../../domain/ContentoAccessibilities';
import {
    StyledTopAreaVariantIcon,
    StyledTopAreaVariantLink,
    StyledTopAreaVariantNoWrap,
} from './TopAreaVariant.styles';

const TopAreaVariant = ({ index, variant, onClick }) => {
    let prepend = index > 0 ? ' och ' : '';
    if (variant.accessibility !== CONTENTO_ACCESSIBILITIES.DEFAULT && index === 0) {
        prepend += 'som ';
    }

    return (
        <>
            {prepend}
            <StyledTopAreaVariantNoWrap>
                <StyledTopAreaVariantIcon accessibility={variant.accessibility} />
                <OpenModal videoId={variant.svtId} videoUrl={variant.urls.svtplay}>
                    <StyledTopAreaVariantLink
                        onClick={() => onClick(variant.accessibility)}
                        data-rt="top-area-a11y-link"
                    >
                        {getAccessServiceDescription(variant.accessibility)}
                    </StyledTopAreaVariantLink>
                </OpenModal>
            </StyledTopAreaVariantNoWrap>
        </>
    );
};

export default TopAreaVariant;
